import { Component, EventEmitter, Output } from '@angular/core';
import { ISidebarItem } from '../../../../nvps-libraries/design/nv-sidebar-list/nv-sidebar.interface';

@Component({
  selector: 'network-settings-right-nav',
  template: require('./network-settings-right-nav.component.html'),
  styles: [require('./network-settings-right-nav.component.scss')],
})
export class NetworkSettingsRightNavComponent {
  @Output() clickedAddUser = new EventEmitter();

  title = 'Tools';
  sidebarItems: ISidebarItem[] = [
    {
      human: 'Add user',
      key: 'addUser',
      icon: 'person-add',
    },
  ];

  onSelectItem($selectedKey: string): void {
    switch ($selectedKey) {
      case 'addUser':
        this.clickedAddUser.emit();
        break;
      default:
        break;
    }
  }
}
